import Link from 'next/link'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { getProductUrl, slugify } from '@dustin-web/microsite-components/src/utils/urls'

export default function ProductHeadingLink({
  product,
  trackPushSelectItem,
}: {
  product: CartItemFragment['product']
  trackPushSelectItem: () => void
}) {
  const { userData } = useAuth()
  const allowedToClickMandatoryAccessories = userData ? userData.allowImpersonateContact : false
  if (!product) return null
  return (
    <>
      {product.internalProduct && !allowedToClickMandatoryAccessories ? (
        <span>
          {product.manufacturerName} {product.displayName} {product.displaySpecifications}
        </span>
      ) : (
        <Link
          className="a-stripped line-clamp"
          href={getProductUrl(
            product.productErpIdentifier,
            slugify(product.displayName ?? '') || ''
          )}
          onClick={trackPushSelectItem}
        >
          {product.manufacturerName} {product.displayName} {product.displaySpecifications}
        </Link>
      )}
    </>
  )
}
